//import liraries
import React, { useState, useEffect } from "react";
import {View, Text, TextInput, TouchableOpacity, Image, FlatList, Dimensions, Linking,} from "react-native";
import ChartPie from "@garvae/react-pie-chart";
import moment from "moment";
import { get, isEmpty, set } from "lodash";
import {  getAllVehiclesListApi,  getDashFastags } from "../../api/apiManager";
import {  getVehicleDetails,expenseStatsByDate } from "../../api/serviceRequest";
import Loader from "../../common/Loader";
import * as RootNavigation from "../../utilities/RootNavigation";
import { useApiContext } from "../../api/ApiContext";
import CImage from "../../common/CImage";
import useStyles from "./DashboardCard_Styles";

const isSmallDevice = Dimensions.get("window").width < 767;
const isTabView = Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024;

const DashboardCard = (props) => {
  const { vehicleList } = useApiContext();
  const styles = useStyles();
  const [searchText, setSearchText] = useState("");
  const [showSearchDropdown, setShowSearchDeopdown] = useState(false);
  const [statData, setStatData] = useState([]);
  const [vrnList, setVrnList] = useState([]);
  const [dashFastag, setDashFastag] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedMonth, setSelectedMonth] = useState(moment().format("MMM YY"));
  const [vrnDetails, setVrnDetails] = useState("");
  const [VEHICLE_LIST, SET_VEHICLE_LIST] = useState([])
  const [DASH_FASTAG, SET_DASH_FASTAG] = useState({})
  const ref = React.useRef();
  const tabref = React.useRef();
  const [showDropdown, setShowDropdown] = useState(false)

  const getExpenseData = (vrn) => {
    setLoading(true)
    const startOfMonth = moment(selectedMonth, "MMM YYYY")
      .startOf("month")
      .format("YYYY-MM-DD");
    const endOfMonth =
      selectedMonth == moment().format("MMM YY")
        ? moment().format("YYYY-MM-DD") : moment(selectedMonth, "MMM YYYY").endOf("month").format("YYYY-MM-DD");
    let reqObj = { vrn: vrn,  fromDate: startOfMonth, toDate: endOfMonth, };
    expenseStatsByDate(reqObj)
      .then((res) => {
        setLoading(false)
        if (res.statusCode == 200) { 
          const data= res?.data 
          setStatData([
            { color: get(data[0], "fastagSumAmount", 0) ? "#837FE1" : "gray",
              order: 1,
              segmentId: "001",
              value: get(data[0], "fastagSumAmount", 0),
            },
            { color: "#C962DF",
              order: 2,
              segmentId: "002",
              value: get(data[0], "fuelSumAmount", 0),
            },
            { 
              color: get(data[0], "fastagSumAmount", 0) ? "#3BC5E4" : "gray",
              order: 3,
              segmentId: "003",
              value: get(data[0], "parkingSumAmount", 0) == 0 ? 0.00 : get(data[0], "parkingSumAmount", 0),
            },
          ]);

        }
      })
      .catch((err) => { setLoading(false) });
  };

  const generateLast3MonthDrop = () => {
    let lastmonths = [];
    lastmonths.push(moment().format("MMM YY"));
    for (let i = 1; i < 3; i++) {lastmonths.push(moment(moment().subtract(i, "months").calendar()).format("MMM YY") ); }
    return lastmonths;
  };

  useEffect(() => {  setDashFastag(DASH_FASTAG);}, [DASH_FASTAG]);

  useEffect(() => {
    if (vehicleList.length > 0) {SET_VEHICLE_LIST(vehicleList)}
  }, [vehicleList])

  useEffect(() => {
    let vrnArr = VEHICLE_LIST.map((item) => item.vrn);
    setVrnList(vrnArr);
  }, [VEHICLE_LIST]);

  const getDetails = (vrn) => {
    setLoading(true)
    getVehicleDetails(vrn)
      .then((res) => {
        setLoading(false)
        if (res?.statusCode == 200) {setVrnDetails(res.data);}
      })
      .catch((err) => { setLoading(false) });
  };

  useEffect(() => {if (selectedMonth) {getExpenseData(""); }}, [selectedMonth]);

  useEffect(() => { setSelectedMonth(moment().format("MMM YY"));}, []);

  const getAllVehiclesList = () => {
    if (isEmpty(vehicleList) || vehicleList.length === 0) {
    setLoading(true)
    console.log("getalluser==>", vehicleList )
      getAllVehiclesListApi()
      .then((res) => {
        setLoading(false)
        SET_VEHICLE_LIST(res);
      })
      .catch((err) => { setLoading(false) })
    } }

  const getDashFastagData = () => {
    setLoading(true)
    getDashFastags().then(res => {
      setLoading(false)
      SET_DASH_FASTAG(res?.data)
    }).catch(err => { setLoading(false) })
  }
  useEffect(() => {
    getAllVehiclesList()
    getDashFastagData()
  }, []);
  return (
    <View style={styles.container}>
         <View style={styles.expenseContainerStyle}>
        <Text style={styles.headerTextStyle}>{"EXPENSE STATISTICS"}</Text>
        <View style={styles.viewStyle}>
          <View style={styles.tabViewChartPieStyle}>
            <View ref={tabref} style={styles.chartpieViewStyle}>
              <ChartPie
                donutHoleClassName={"#fffff"}
                data={statData ? statData : 0} 
                parentRef={tabref}
                text={<View style={{ alignItems: "center" }}>
                      <Text style={styles.chartpieTextStyle}>{"Total"}</Text>
                      <Text style={styles.chartpieTotalAmtTextStyle}>
                        {"\u20B9"}
                        {statData?.length
                          ? statData[0]?.value +
                          statData[1]?.value +
                          statData[2]?.value
                          : 0}
                      </Text>
                      <Text style={styles.chartpieTextStyle}>
                        {selectedMonth}
                      </Text>
                    </View>
                  }
              />
            </View>
            <View style={styles.viewStyle1}>
              <View style={styles.tagDetails}>
                <View style={styles.verticalLineStyle} />
                <View style={{ paddingLeft: 5 }}>
                  <Text style={[styles.amoutText, { marginTop: 2 }]}> {"\u20B9"} {statData.length ? statData[0]?.value : 0} </Text>
                  <Text style={[styles.textSmall, { marginTop: 0, opacity: 0.6 }]} > {"toll"} </Text>
                </View>
              </View>
              <View style={styles.tagDetails}>
                <View style={[styles.verticalLineStyle, { backgroundColor: "#C962DF" } ]} />
                <View style={{ paddingLeft: 5 }}>
                  <Text style={[styles.amoutText, { marginTop: 2 }]}> {"\u20B9"} {statData?.length ? statData[1]?.value : 0} </Text>
                  <Text style={[styles.textSmall, { marginTop: 0, opacity: 0.6 }]} > {"fuel"}</Text>
                </View>
              </View>
              <View style={styles.tagDetails}>
                <View style={[styles.verticalLineStyle,{ backgroundColor: "#3BC5E4" }, ]} ></View>
                <View style={{ paddingLeft: 5 }}>
                  <Text style={[styles.amoutText, { marginTop: 2 }]}>
                    {"\u20B9"} {statData?.length ? statData[2]?.value : 0}
                  </Text>
                  <Text style={[styles.textSmall, { marginTop: 0, opacity: 0.6 }]} >{"parking"}</Text>
                </View>
              </View>
            </View>
          </View>
          <View style={styles.viewStyle2}>
            <View style={styles.viewStyle3}>
              <View style={styles.inputContainer}>
                <TextInput
                  value={searchText}
                  onChangeText={(t) => {
                    setSearchText(t), setShowSearchDeopdown(true);
                  }}
                  style={[ styles.input,{borderBottomLeftRadius:searchText.length > 2 && showSearchDropdown ? 0 : 10,borderBottomRightRadius: searchText.length > 2 && showSearchDropdown ? 0 : 10, }, ]}
                  placeholder={"Search"}
                />
                <Image source={require("../../assets/images/searchIcon.png")} style={styles.searchIcon}/>
                {searchText.length > 2 && showSearchDropdown ? (
                  <View style={styles.dropdownStyle}>
                    <FlatList
                      data={vrnList.filter(item=> {return item.includes(searchText.toUpperCase())})}
                      keyExtractor = {(item, index) => index+"_"+item?.id?.toString() }
                      renderItem={({ item }) => {
                        return (
                          <TouchableOpacity
                            style={{ paddingHorizontal: 10, justifyContent: "center", }}
                            onPress={() => {
                              //will cal on selection
                              getExpenseData(item);
                              getDetails(item);
                              setSearchText(item), setShowSearchDeopdown(false);
                            }}
                          >
                            <Text style={{ paddingVertical: 10 }}>{item}</Text>
                            <View
                              style={styles.bgView}
                            />
                          </TouchableOpacity>
                        );
                      }}
                    />
                  </View>
                ) : null}

              </View>
              <View style={styles.viewStyle4}>
                <TouchableOpacity style={styles.dropdownViewStyle} onPress={() => setShowDropdown(true)} >
                  <Text style={styles.selectedMonthTextStyle}>
                    {selectedMonth}
                  </Text>
                </TouchableOpacity>
                {showDropdown && (
                  <View style={styles.dropdownContainerStyle}>
                    {generateLast3MonthDrop().map((month, index) => {
                      return (
                        <TouchableOpacity
                          style={styles.dropdownItemViewStyle}
                          onPress={() => {
                            setSelectedMonth(month);
                            setShowDropdown(false);
                          }}
                        >
                          <Text style={styles.dropdownTextStyle}>{month}</Text>
                        </TouchableOpacity>
                      );
                    })}
                  </View>
                )}
              </View>
            </View>
            <View style={ styles.addFavourateViewStyle }  >
            <Text>
              {vrnDetails ? (
                <View
                  style={{
                    flexDirection: "row",
                    paddingHorizontal: 20,
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Text style={styles.fastagNbr}>
                    {"FASTag No #"}
                    {get(vrnDetails, "fastagId", 0)}
                  </Text>
                  <Text style={styles.fastagBal} >
                    {"\u20B9"} {get(vrnDetails, "fastagBalance", 0)}
                  </Text>
                </View>
              ) : (
                null
              )}
          </Text>
              <View
                style={{
                  flexDirection: "row",
                  paddingHorizontal: 20,
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >

                <TouchableOpacity
                  style={styles.btnRecharge}
                  onPress={() =>{ RootNavigation.navigate("Recharge")
                    global.activeScreen = "Recharge"
                  }}
                >
                  <Text style={styles.btnRechargeText}>
                    {"Recharge"}
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
            <View style={styles.chartpieView}>
              <View ref={ref} style={styles.chartpieViewStyle}>
                <ChartPie
                  donutHoleClassName={"#fffff"}
                  data={statData}
                  parentRef={ref}
                  text={
                    <View style={{ alignItems: "center" }}>
                      <Text style={styles.chartpieTextStyle}>{"Total"}</Text>
                      <Text style={styles.chartpieTotalAmtTextStyle}>
                        {"\u20B9"}
                        {statData?.length
                          ? statData[0]?.value +
                          statData[1]?.value +
                          statData[2]?.value
                          : 0}
                      </Text>
                      <Text style={styles.chartpieTextStyle}>
                        {selectedMonth}
                      </Text>
                    </View>
                  }
                />
              </View>
              <View style={styles.viewStyle1}>
                <View style={styles.tagDetails}>
                  <View style={styles.verticalLineStyle} />
                  <View style={{ paddingLeft: 5 }}>
                    <Text style={[styles.amoutText, { marginTop: 2 }]}>
                      {"\u20B9"}
                      {statData?.length
                        ? statData[0]?.value.toString().includes(".")
                          ? statData[0]?.value.toFixed(2)
                          : statData[0]?.value + ".00"
                        : 0}
                    </Text>
                    <Text style={[styles.textSmall, { marginTop: 0, opacity: 0.6 }]} > {"toll"}</Text>
                  </View>
                </View>
                <View style={styles.tagDetails}>
                  <View style={[ styles.verticalLineStyle,{ backgroundColor: "#C962DF" }, ]} />
                  <View style={{ paddingLeft: 5 }}>
                    <Text style={[styles.amoutText, { marginTop: 2 }]}>
                      {"\u20B9"}
                      {statData?.length
                        ? statData[1]?.value.toString().includes(".")
                          ? statData[1]?.value.toFixed(2)
                          : statData[1]?.value + ".00"
                        : 0}
                    </Text>
                    <Text style={[styles.textSmall, { marginTop: 0, opacity: 0.6 }]} >{"fuel"} </Text>
                  </View>
                </View>
                <View style={styles.tagDetails}>
                  <View style={[  styles.verticalLineStyle,{ backgroundColor: "#3BC5E4" },]} />
                  <View style={{ paddingLeft: 5 }}>
                    <Text style={[styles.amoutText, { marginTop: 2 }]}>
                      {"\u20B9"}
                      {statData?.length
                        ? statData[2]?.value.toString().includes(".")
                          ? statData[2]?.value.toFixed(2)
                          : statData[2]?.value + ".00"
                        : 0}
                    </Text>
                    <Text style={[styles.textSmall, { marginTop: 0, opacity: 0.6 }]}  > {"parking"}</Text>
                  </View>
                </View>
              </View>
            </View>

            <View style={styles.viewStyle5}>
              <Image source={require("../../assets/images/Tag.png")} style={styles.tagImageStyle}/>
              <View style={styles.viewStyle6}>
                <View style={styles.activeViewStyle}>
                  <Text style={styles.textStyle}>{"Active"}</Text>
                  <Text style={[styles.textStyle, { color: "#91ce55" }]}>
                    {get(DASH_FASTAG, "active", 0)}
                  </Text>
                </View>
                <View style={styles.activeViewStyle}>
                  <Text style={styles.textStyle}>{"Low Balance"}</Text>
                  <Text style={[styles.textStyle, { color: "#c32b2c" }]}>
                    {get(DASH_FASTAG, "lowBalance", 0)}
                  </Text>
                </View>
                <View style={styles.activeViewStyle}>
                  <Text style={styles.textStyle}>{"Blacklisted"}</Text>
                  <Text style={[styles.textStyle, { color: "#ff931e" }]}>
                    {get(DASH_FASTAG, "blackListed", 0)}
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </View>
      </View>
      
      {loading && <Loader />}
    </View>
  );
};

//make this component available to the app
export default DashboardCard;
